export default __webpack_public_path__ + "static/background-home-424cc1d52ad8b004c31ccffd36d4dc37.png";